enum Sex {
  Female = 'F',
  Male = 'M',
}

export default Sex
